module.exports = __webpack_public_path__ + "img/asian-special-1.422197c7.jpg";